import { createRouter, createWebHistory, useRoute } from 'vue-router'
import { destroyUserCredentials, getuserRole } from '@/utils/userCredentials'
import { useToast } from '@/composables/useToast'
import OpportunityShow from '@/components/opp/OpportunityShow.vue'
import HomeView from '@/views/HomeView.vue'
import OpportunityIndex from '@/components/opp/OpportunityIndex.vue'
import CreateOpportunity from '@/components/admin/CreateOpportunity.vue'
import IndexOpportunity from '@/components/admin/IndexOpportunity.vue'
import EditOpportunity from '@/components/admin/EditOpportunity.vue'
import AppLogin from '@/components/auth/AppLogin.vue'
import AppSignup from '@/components/auth/AppSignup.vue'
import AboutView from '@/views/AboutView.vue'

const { showToast } = useToast()
const route = useRoute()
const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView,
    meta: {
        title: 'Home',
        layout: 'home'
    }
  },
  {
    path: '/about',
    name: 'About',
    component: AboutView,
    meta: {
      title: 'About',
      layout: 'home'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: AppLogin,
    meta: {
      layout: 'home',
      title: 'Login',
      guestOnly: true
    }
  },
  {
    path: '/register',
    name: 'register',
    component: AppSignup,
    meta: {
      layout: 'home',
      title: 'Signup',
      guestOnly: true
    }
  },
  {
    path: '/opportunities',
    name: 'OpportunityIndex',
    component: OpportunityIndex,
    meta: {
      title: 'Opportunities'
    }
  },
  {
    path: '/opportunity/:id',
    name: 'OpportunityShow',
    component: OpportunityShow,
    props: true,
    meta: {
      title: 'Opportunity'
    }
  },
  {
    path: '/admin/opportunities/create',
    name: 'OpportunityCreate',
    component: CreateOpportunity,
    meta: {
      layout: 'admin',
      title: 'Add Opportunity',
      requiresAuth: true,
      role: 'admin'
    }
  },
  {
    path: '/admin/opportunities/:id/edit',
    name: 'OpportunityEdit',
    component: EditOpportunity,
    meta: {
      layout: 'admin',
      title: 'Edit Opportunity',
      requiresAuth: true,
      role: 'admin'
    }
  },
  {
    path: '/admin/opportunities',
    name: 'IndexOpportunity',
    component: IndexOpportunity,
    meta: {
      layout: 'admin',
      title: 'Dashboard',
      requiresAuth: true,
      role: 'admin'
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const isLoggedIn = !!localStorage.getItem('user_token')
  document.title = ( to.meta.title || 'Untitled' ) + ' | OPPI'

  if (to.matched.length == 0)
  {
    showToast('The requested path does not exist!', 'warning')
    next({ name: 'OpportunityIndex' })
  }

  if (requiresAuth && !isLoggedIn) {
    showToast('Please login to continue!', 'warning')
    next({ name: 'Login', query: { redirect: to.fullPath } })

  }

  if (to.meta.guestOnly && isLoggedIn) {
    showToast('User already logged in!', 'warning')
    next({ name: 'OpportunityIndex' })
  }

  if (to.meta.role === 'admin') {
    const role = await getuserRole()
    if (!role)
    {
      destroyUserCredentials()
      showToast('User logged out!', 'success')
      route.push({
        name: 'OpportunityIndex'
      })
      return
    }
    if (role === to.meta.role)
    {
      next()
    }
    if (role.length > 0) {
      showToast('Forbidden Request!', 'danger')
      next({ name: 'OpportunityIndex' })
    }
  }
    
  next()
})

export default router
